import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12.833 6.75a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM18.083 13.5a5.25 5.25 0 1 0-10.5 0v2.25h2.25l.75 7.5h4.5l.75-7.5h2.25V13.5Z"
    }, null, -1)
  ]))]))
}
export default { render: render }